import React, { useState } from 'react';

import { IconButton, ListItemIcon, ListItemText, Menu, MenuItem, Tooltip } from '@mui/material';
import LightModeIcon from '@mui/icons-material/LightMode';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import SettingsBrightnessIcon from '@mui/icons-material/SettingsBrightness';
import CheckIcon from '@mui/icons-material/Check';

import { ColorModePreferenceEnum, useColorMode } from '../../theme';

const preferenceIcons = {
    [ColorModePreferenceEnum.LIGHT.value]: <LightModeIcon fontSize="small"/>,
    [ColorModePreferenceEnum.DARK.value]: <DarkModeIcon fontSize="small"/>,
    [ColorModePreferenceEnum.SYSTEM.value]: <SettingsBrightnessIcon fontSize="small"/>
};

const ColorModeToggle = () => {
    const { mode, preference, setPreference } = useColorMode();
    const [anchorEl, setAnchorEl] = useState(null);

    return (
        <>
            <Tooltip title="Motyw">
                <IconButton color="inherit" onClick={ event => setAnchorEl(event.currentTarget) } aria-label="Zmień motyw">
                    { mode === ColorModePreferenceEnum.DARK.value ? <DarkModeIcon/> : <LightModeIcon/> }
                </IconButton>
            </Tooltip>
            <Menu anchorEl={ anchorEl } open={ !!anchorEl } onClose={ () => setAnchorEl(null) }>
                {
                    Object.values(ColorModePreferenceEnum).map(item => (
                        <MenuItem
                            key={ item.value }
                            selected={ preference === item.value }
                            onClick={ () => {
                                setPreference(item.value);
                                setAnchorEl(null);
                            } }
                        >
                            <ListItemIcon>{ preferenceIcons[item.value] }</ListItemIcon>
                            <ListItemText primary={ item.label }/>
                            { preference === item.value && <CheckIcon fontSize="small" sx={ { ml: 2 } }/> }
                        </MenuItem>
                    ))
                }
            </Menu>
        </>
    );
};

export default ColorModeToggle;
